export default "__VITE_ASSET__g1D898f3__"